// extracted by mini-css-extract-plugin
module.exports = {"msg":"ErrorMessage_msg__3BDtL","static":"ErrorMessage_static__1bqiw"};